import ProgressBar from 'react-bootstrap/ProgressBar';
import React, { useState, useEffect } from 'react';
import './styles.css'


function GoalPercentage() {

  const [data, setData] = useState([]);

  useEffect(() => {
    // Substitua pelo link CSV da sua planilha
    const sheetUrl = process.env.REACT_APP_SHEET_1_URL

    fetch(sheetUrl)
      .then((response) => response.text())
      .then((csvText) => {
        const rows = csvText.split('\n').map((row) => row.split(','));
        setData(rows);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);



  if (data.length === 0) {
    return null; // Retorna null em vez de spinner, deixa o skeleton da página principal gerenciar o loading
  }

  const yValues4 = data.slice(1).map((row) => Number(row[3]) || null); // Supondo que a coluna 4 é a segunda variável
  const dates = data.slice(1).map((row) => new Date(row[0])); // Coluna 0 contém as datas

  // Combina as datas com seus respectivos valores
  const combinedData = dates.map((date, index) => ({
    date,
    value: yValues4[index]
  }));

  // Ordena o array combinado pela data, da mais recente para a mais antiga
  combinedData.sort((a, b) => b.date - a.date);

  // Pega o valor correspondente à data mais recente
  const mostRecentValue = combinedData[0].value;
  const percentage = (Number(mostRecentValue) / 200000) * 100
  const percentageDec = percentage.toFixed(1)
  const percentageDiff = (100 - percentage)


  return (

    <div className='container-fluid w-100  justify-content-center align-items-center'>

      <div className='pad100'>
        <div className='text-align-center'>
          <p >Falta <b>{percentageDiff !== null ? `${percentageDiff.toFixed(1).toLocaleString('pt-BR').replace(".", ",")}%` : 'Carregando...'}</b> para a meta de <b>R$ 200.000,00</b></p>
        </div>
        <ProgressBar className='green-progress-bar barHeight' label={`${percentageDec}%`} animated now={percentage} />
      </div>
    </div>

  )
}

export default GoalPercentage;